module.exports = __webpack_public_path__ + "img/soft-icon.1028ec2.webp";